/**
 * @providesModule Colors
 */
export const colors = {
  white: '#FFFFFF',
  whitebg: '#fbfbfb',
  black: '#000000',
  transparent: 'transparent',
  border: '#ebedef',

  base: {
    darkBlack: '#081428',
    primary: '#B7002C',
    red: '#D30202',
    green: '#2FA766',
    blue: '#466FF7',
    yellow: '#FEEF06',
    orange: '#FCEAC8',
    grayBg: '#C2C1CD33',
    grayDark: '#3F4352',
  },

  btn: {
    red: '#EE4E68',
    Darkred: '#B7002C',
    green: '#47BB75',
    blue: '#30B0C7',
    yellow: '#F6BA47',
    gray: '#A4A4A4',
    check: '#777E90',
  },

  text: {
    placeholder: '#777E90',
    primary: '#1C1E24',
    secondary: '#FCFCFD',
    green: '#358D0C',
    blue: '#466FF7',
    orange: '#D99920',
    neutral: '#777E90',
    red: '#D30202',
  },

  chart: {
    red: '#B7002C',
    green: '#358D0C',
    blue: '#007AFF',
    orange: '#D97D28',

    rgb_red: '183, 0, 44',
    rgb_green: '53, 141, 12',
    rgb_blue: '0, 123, 255',
    rgb_orange: '217, 125, 40',
  },
};

export const shadows = {
  xs: {
    shadowColor: '#101828',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.05,
    shadowRadius: 2,
  },
  sm: {
    shadowColor: '#101828',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.08,
    shadowRadius: 3,
  },
  md: {
    shadowColor: '#101828',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.12,
    shadowRadius: 6,
  },
  lg: {
    shadowColor: '#101828',
    shadowOffset: {width: 0, height: 8},
    shadowOpacity: 0.15,
    shadowRadius: 12,
  },
};
